export type ComposerPopupPosition = {
  left: number;
  bottom: number;
  width: number;
  maxHeight: number;
};

export function getComposerPopupPosition(
  button: HTMLButtonElement,
  maxWidth: number,
): ComposerPopupPosition {
  const rect = button.getBoundingClientRect();
  const width = Math.min(maxWidth, window.innerWidth - 16);
  return {
    left: Math.max(8, Math.min(rect.left, window.innerWidth - width - 8)),
    bottom: window.innerHeight - rect.top + 8,
    width,
    maxHeight: Math.max(160, Math.min(512, rect.top - 16)),
  };
}

export function anchorComposerPopup(
  button: HTMLButtonElement,
  anchor: { current: HTMLButtonElement | null },
  setPosition: (position: ComposerPopupPosition) => void,
  maxWidth: number,
) {
  anchor.current = button;
  setPosition(getComposerPopupPosition(button, maxWidth));
}
